/**
 * Created by Jerker Nord on 2021-09-02.
 */
import {BenjiKIV} from "../BenjiKIV";

export interface IWinRatioConfig {
    readonly duration:number;
    readonly type:string;
}

export interface BigWinLevel {
    from:number;
    to:number;
    duration:number;
    id:number;
    name:string;
}

export class BenjiKIVWinConfigs {

    public static TINY = "tiny";
    public static SMALL = "small";
    public static MEDIUM = "medium";
    public static LARGE = "large";
    public static BIG_WIN_01 = "bigWin01";
    public static BIG_WIN_02 = "bigWin02";
    public static BIG_WIN_03 = "bigWin03";
    public static BIG_WIN_04 = "bigWin04";
    public static BIG_WIN_05 = "bigWin05";
    public static BIG_WIN_06 = "bigWin06";


    public static getWinRatioConfig(ratio:number = BenjiKIV.model.winRatio):IWinRatioConfig {
        let type:string = BenjiKIVWinConfigs.getWinType(ratio);
        const duration:number = BenjiKIVWinConfigs.getCountupDuration(type);
        return {type : type, duration : duration};
    }

    public static getWinType(ratio:number):string {
        if (ratio < 1.5){
            return BenjiKIVWinConfigs.TINY;
        }

        if (ratio < 2.5){
            return BenjiKIVWinConfigs.SMALL;
        }

        if (ratio < 5){
            return BenjiKIVWinConfigs.MEDIUM;
        }

        return BenjiKIVWinConfigs.LARGE;
    }

    public static getBigWinLevels(ratio:number){
        let levels:BigWinLevel[] = []

        if(ratio >= 15) {
            levels.push({
                from:0,
                to:25,
                duration:4.975,
                id:1,
                name:BenjiKIVWinConfigs.BIG_WIN_01
            })
        }

        if(ratio >= 25) {
            levels.push({
                from:25,
                to:50,
                duration:5,
                id:2,
                name:BenjiKIVWinConfigs.BIG_WIN_02
            })
        }

        if(ratio >= 50) {
            levels.push({
                from:50,
                to:100,
                duration:5,
                id:3,
                name:BenjiKIVWinConfigs.BIG_WIN_03
            })
        }

        if(ratio >= 100) {
            levels.push({
                from:100,
                to:500,
                duration:5,
                id:4,
                name:BenjiKIVWinConfigs.BIG_WIN_04
            })
        }

        if(ratio >= 500) {
            levels.push({
                from:500,
                to:Number.MAX_VALUE,
                duration:5,
                id:5,
                name:BenjiKIVWinConfigs.BIG_WIN_05
            })
        }

        levels = BenjiKIVWinConfigs.setLastConfig(ratio, levels);

        return levels;
    }

    private static setLastConfig(winRatio:number, configs:BigWinLevel[]):BigWinLevel[] {
        let lastConfig = configs[configs.length - 1];
        if (lastConfig.from * 1.2 > winRatio && configs.length > 1) {
            configs.pop();
            return BenjiKIVWinConfigs.setLastConfig(winRatio, configs);
        }

        lastConfig.to = winRatio;
        return configs;
    }

    public static getCountupDuration(winType:string):number {
        switch(winType) {
            case BenjiKIVWinConfigs.BIG_WIN_06 :
                return 0; //This is set to 0 to prevent MaxWin outro to play countup sound.
            case BenjiKIVWinConfigs.BIG_WIN_05 :
                return 7;
            case BenjiKIVWinConfigs.BIG_WIN_04 :
                return 7;
            case BenjiKIVWinConfigs.BIG_WIN_03 :
                return 7;
            case BenjiKIVWinConfigs.BIG_WIN_02 :
                return 7;
            case BenjiKIVWinConfigs.BIG_WIN_01 :
                return 7;
            case BenjiKIVWinConfigs.LARGE :
                return 1.689;
            case BenjiKIVWinConfigs.MEDIUM :
                return 1.014;
            case BenjiKIVWinConfigs.SMALL :
                return 0;
            case BenjiKIVWinConfigs.TINY :
                return 0;
            default :
                return 0;
        }
    }
}